// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"313484cb","109":"9323a0fc","125":"8df84e25","193":"bc3cced3","332":"5988ce0b","366":"91d21a2d","394":"60560d18","437":"0d8995f9","525":"dd478e4c","649":"f5641481","779":"c5a36278","890":"1367f442"}[chunkId] + ".chunk.js";
};